import axios from 'axios'
import { deliveryUrl, getHeader } from '../config'

const state = {
  deliveryList: []
}

const mutations = {
  SET_DELIVERY_LIST (state, obj) {
    state.deliveryList = obj
  }
}

const actions = {
  getDeliveryList: ({ commit }) => {
    axios.get(deliveryUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_DELIVERY_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
